import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./home.css";

export default function CarServiceNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);

  return (
    <>
    <Helmet>
      <script type="application/ld+json">
{`
{
  "@context": "https://schema.org",
  "@type": "SiteNavigationElement",
  "name": "AutoCare Navigation",
  "hasPart": [
    {
      "@type": "WebPage",
      "name": "Home",
      "url": "/"
    },
    {
      "@type": "WebPage",
      "name": "Services",
      "url": "/services"
    },
    {
      "@type": "WebPage",
      "name": "About Us",
      "url": "/about"
    },
    {
      "@type": "WebPage",
      "name": "Client Feedback",
      "url": "/feedback"
    },
    {
      "@type": "WebPage",
      "name": "Blog",
      "url": "/blog"
    }
  ]
}
`}
</script>
<title>AutoCare Car Service Navigation</title>
<meta name="description" content="Navigate through AutoCare's car service website with ease. Access home, services, about us, client feedback, blog, and book appointments." />
    </Helmet>
    <header className="outerNav" ref={navRef}>
      {/* Logo */}
      <div className="logo">
        <img src="/carServiceImages/carlogo.png" alt="AutoCare Logo" />
      </div>

      {/* Hamburger (Mobile) */}
      <div
        className={`hamburger ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        ☰
      </div>

      {/* Navigation */}
      <nav className={`navItems ${menuOpen ? "show" : ""}`}>
        <Link className="navItem" to="/" onClick={() => setMenuOpen(false)}>
          Home
        </Link>
        <Link className="navItem" to="/services" onClick={() => setMenuOpen(false)}>
          Services
        </Link>
        <Link className="navItem" to="/about" onClick={() => setMenuOpen(false)}>
          About Us
        </Link>
        <Link className="navItem" to="/feedback" onClick={() => setMenuOpen(false)}>
          Client Feedback
        </Link>
        <Link className="navItem" to="/blog" onClick={() => setMenuOpen(false)}>
          Blog
        </Link>

        <Link to="/contact" onClick={() => setMenuOpen(false)}>
          <button className="bookAppointment">Book Appointment</button>
        </Link>
      </nav>
    </header>
    </>
  );
}
